<template>
  <div class="mobile-home">
    <!-- 移动端顶部导航 -->
    <div class="mobile-header">
      <div class="mobile-logo">
        <img class="logo-img" src="@/assets/img/logo.png" alt="logo" />
        <span class="logo-text">正企元</span>
      </div>
      <div class="menu-icon" @click="toggleMenu">
        <i class="el-icon-menu"></i>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div class="mobile-menu" v-show="menuVisible">
      <div v-for="(item, index) in navItems" :key="index" class="menu-item" :class="{ active: activeNav === item.id }"
        @click="scrollToSection(item.id)">
        {{ item.title }}
      </div>
    </div>

    <!-- 移动端内容区域 -->
    <div class="mobile-content">
      <!-- 顶部banner区域 -->
      <div id="home" class="mobile-banner-section">
        <!-- <h1 class="mobile-title">正企元数字科技</h1>
        <p class="mobile-subtitle">数字化转型全栈解决方案提供商</p> -->
      </div>

      <!-- 公司简介区域 -->
      <div id="building" class="mobile-building-section">
        <img class="mobile-image" src="@/assets/img/build.png" alt="" />

        <div class="mobile-article">
          <div class="CompanyTop">
            <div class="CompanyName">公司简介</div>
            <div class="English">&nbsp;&nbsp;/&nbsp;&nbsp;WHO WE ARE</div>
          </div>
          <p>
            杭州正企元数字科技有限公司(简称"正企元数字科技")成立于2025年，总部坐落于中国数字经济高地--杭州市上城区临丁路1190号-尚坤丁兰国际，是一家以人工智能、大数据、云计算为核心驱动力的创新型科技企业。公司致力于为政府、企业及行业伙伴提供数字化转型全栈解决方案，助力客户在智能数字时代实现数字创造价值。
          </p>
          <p>
            在数字化时代浪潮的前沿，正企元以科技为笔，智慧为墨，绘制出一幅前所未有的数据蓝图。我们不仅是守护者，更是开拓者，致力于将数字科技、信息、确权、资产、处理、流通、共享、交易、价值与安全融为一体，打造数据资产服务领域的璀璨星辰。
          </p>
        </div>
      </div>

      <!-- 核心技术区域 -->
      <div id="service" class="mobile-service-section">
        <div class="section-header">
          <div class="section-title">核心技术</div>
          <div class="section-subtitle">CORE TECHNOLOGY</div>
        </div>
        <div class="mobile-service-items">
          <div class="step" v-for="(step, index) in serviceSteps" @click="toggleCore(step, index)" :key="index"
            :class="{ 'active': step.active }">
            <div class="step-icon" style="width: 6.05rem;height:6.05rem;" :class="{ 'active': step.active }"
              :style="{ backgroundImage: `url(${step.bgImage})` }">
              <span class="worksName">{{ step.name }}</span>
              <span class="worksDesc" >{{ step.desc }}</span>
            </div>
            <div class="step-dot">
              <img class="step-img" :src="step.icon" alt="" />
            </div>
          </div>
        </div>
      </div>

      <!-- 产品服务区域 -->
      <div id="product" class="mobile-product-section">
        <div class="section-header">
          <div class="section-title">产品服务</div>
          <div class="section-subtitle">PRODUCT SERVICES</div>
        </div>
        <div class="product-grid">
          <div class="product-item">
            <div class="product-icon">
              <div class="icon-default">
                <span class="title">产品服务</span>
              </div>
              <div class="icon-hover" >
                <span class="desc">
                <span class="descTitle">平台服务</span>
                <span>1、数字确权服务</span>
                <span>2、确权社交服务</span>
                <span>3、还价电商服务</span>
                <span>4、品牌营销服务</span>
                <span class="descTitle2">MORE →</span>
              </span>
              </div>
            </div>
          </div>
          <div class="product-item">
            <div class="product-icon">
              <div class="icon-default">
                <span class="title">软件服务</span>
              </div>
              <div class="icon-hover">
                <span class="desc">
                  <span class="descTitle">软件服务</span>
                <span>1、生产管理系统</span>
                <span>2、私域电商系统</span>
                <span>3、确权收银系统</span>
                <span>4、仓库管理系统</span>
                <span class="descTitle2">MORE →</span>
                </span>
              </div>
            </div>
          </div>
          <div class="product-item">
            <div class="product-icon">
              <div class="icon-default">
                <span class="title">数据服务</span>
              </div>
              <div class="icon-hover">
                <span class="desc">
                  <span class="descTitle">数据服务</span>
                <span>1、数字确权服务</span>
                <span>2、数据储存服务</span>
                <span>3、数据共享服务</span>
                <span>4、数据增值服务</span>
                <span class="descTitle2">MORE →</span>
              </span>
              </div>
            </div>

          </div>
          <div class="product-item">
            <div class="product-icon">
              <div class="icon-default">
                <span class="title">品牌企业 <span>服务</span></span>
              </div>
              <div class="icon-hover">
                <span class="desc">
                  <span class="descTitle">品牌服务</span>
                <span>1、增量广告服务</span>
                <span>2、知识产权服务</span>
                <span>3、品牌策划服务</span>
                <span>4、品牌增量服务</span>
                <span class="descTitle2">MORE →</span>
              </span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- 服务流程区域 -->
      <div id="liucheng" class="mobile-liucheng-section">
        <div class="section-header">
          <div class="section-title">服务流程</div>
        </div>
        <img class="liucheng-img" src="@/assets/img/liucheng.png" alt="服务流程" />
      </div>

      <!-- 扫码下载区域 -->
      <div id="code" class="mobile-code-section">
        <div class="section-header">
          <div class="section-title">扫码下载app</div>
          <div class="section-subtitle">ZENBAY</div>
        </div>
        <div class="code-container">
          <img class="code-img" src="@/assets/img/appCode.png" alt="扫码下载" />
        </div>
      </div>

      <!-- 联系我们区域 -->
      <div id="map" class="mobile-map-section">
        <div class="section-header">
          <div class="section-title">联系我们</div>
          <div class="section-subtitle">CONTACT US</div>
        </div>
        <!-- <Map class="mobile-map" /> -->
        <data class="indfoData">
          <div class="contact-info">
            <div class="contact-title">有需要联系我们</div>
            <div class="contact-desc">有任何问题，联系我们或者留下信息，我们将拜访你</div>
            <div class="contact-item">联系电话：17513724567</div>
            <div class="contact-item">邮 箱：zhengqiyuan268@126.com</div>
          </div>
          <div class="contact-form">
            <div class="form-title">我们如何联系您</div>
            <input class="form-input" v-model="input" placeholder="我们要如何称呼您" />
            <input class="form-input" v-model="input2" placeholder="公司名称" />
            <input class="form-input" v-model="input3" placeholder="联系方式" />
            <input class="form-input" v-model="input4" placeholder="合作方向，意见建议，备注等" />
            <div class="form-button">发送</div>
          </div>
        </data>

      </div>

      <!-- 底部区域 -->
      <div class="mobile-footer">
        <div class="footer-container">
          <div class="footer-section">
            <div class="footer-title">产品核心</div>
            <div class="footer-item">核心技术</div>
            <div class="footer-item">核心业务</div>
          </div>
          <div class="footer-section">
            <div class="footer-title">管理系统</div>
            <div class="footer-item">数字确权社交系统</div>
            <div class="footer-item">私域电商管理系统</div>
            <div class="footer-item">品牌管理服务系统</div>
          </div>
          <div class="footer-section">
            <div class="footer-title">关于我们</div>
            <div class="footer-item">公司简介</div>
            <div class="footer-item">联系信息</div>
          </div>
          <div class="footer-qrcode">
            <div class="footer-title">关注我们</div>
            <img class="qrcode-img" src="../assets/img/gongzhongcode.jpg" alt="二维码" />
          </div>
        </div>
        <div class="beian">Copyright © 2025 杭州正企元数字科技有限公司 ｜ <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2025181804号-1</a> ｜ <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010202005094" target="_blank">浙公网安备33010202005094号</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import Map from "@/components/map.vue";

export default {
  name: 'MobileHomeView',
  components: {
    Map,
  },
  data() {
    return {
      menuVisible: false,
      activeNav: 'home',
      input: "",
      input2: "",
      input3: "",
      input4: "",
      navItems: [
        { id: 'home', title: '首页' },
        { id: 'building', title: '公司简介' },
        { id: 'service', title: '核心技术' },
        { id: 'product', title: '产品服务' },
        { id: 'liucheng', title: '服务流程' },
        { id: 'code', title: 'app下载' },
        { id: 'map', title: '联系我们' },
      ],
      serviceSteps: [
        { name: '确权社交', desc: '数字确权社交技术', icon: require('@/assets/img/logo/lianjie.png'), active: false, bgImage: require('@/assets/img/bg.png'), iconName: 'lianjie' },
        { name: '还价电商', desc: '确权还价电商管理技术', icon: require('@/assets/img/logo/dianshang.png'), active: false, bgImage: require('@/assets/img/bg.png'), iconName: 'dianshang' },
        { name: '品牌管理', desc: '智能化品牌提升技术', icon: require('@/assets/img/logo/pinpai.png'), active: false, bgImage: require('@/assets/img/bg.png'), iconName: 'pinpai' },
        { name: '智慧营销', desc: '智慧增量广告营销技术', icon: require('@/assets/img/logo/yingxiao.png'), active: false, bgImage: require('@/assets/img/bg.png'), iconName: 'yingxiao' },
        { name: '执行管理', desc: '智慧增量广告营销技术', icon: require('@/assets/img/logo/zhixing.png'), active: false, bgImage: require('@/assets/img/bg.png'), iconName: 'zhixing' },
      ]
    };
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    scrollToSection(id) {
      this.menuVisible = false;
      this.activeNav = id;
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    //核心技术点击事件
    toggleCore(item, index) {
      console.log('点击项:', item, index);

      // 重置所有step的active状态和背景图
      this.serviceSteps.forEach((step, i) => {
        // 先保存当前图标路径
        const currentIcon = step.icon;

        step.active = false;
        step.bgImage = require('@/assets/img/bg.png');

        // 重置图标为不带2的图标
        if (i !== index) { // 只重置非当前点击的项
          const normalIcon = require(`@/assets/img/logo/${step.iconName}.png`);
          console.log(`重置第${i}项图标:`, normalIcon);
          step.icon = normalIcon;
        }
      });

      // 设置当前点击的step为active，并更改背景图和图标
      this.serviceSteps[index].active = true;
      this.serviceSteps[index].bgImage = require('@/assets/img/bg2.png');

      // 修改当前图标为带2的图标
      const iconPath = require(`@/assets/img/logo/${this.serviceSteps[index].iconName}2.png`);
      console.log('设置图标路径:', iconPath);

      // 使用Vue的$set方法确保响应式更新
      this.$set(this.serviceSteps[index], 'icon', iconPath);

      // 强制更新视图
      this.$forceUpdate();

      console.log('当前选中项:', this.serviceSteps[index]);
    },
    // 在methods中添加防抖函数
    debounceToggleCore(item, index) {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.toggleCore(item, index);
      }, 200); // 200ms防抖时间
    },
    // 处理产品项悬停效果
    handleProductHover(event, isEnter) {
      const productItem = event.currentTarget;
      const productItems = document.querySelectorAll(".product-item");
      const index = Array.from(productItems).indexOf(productItem);

      // 获取产品项的宽度和当前边距
      const itemWidth = 5.54; // 产品项原始宽度
      const expandedWidth = 11.09; // 悬浮时的宽度（原宽度的2倍）


      if (isEnter) {
        // 鼠标进入时
        // 计算悬浮项需要向左移动的距离，以保持视觉中心不变
        const hoverItemLeftShift = (expandedWidth - itemWidth) / 5;

        // 设置悬浮项的变换
        productItem.style.transform = `translateX(-${hoverItemLeftShift}px)`;
        console.log(hoverItemLeftShift, "向左移动的距离");

        // 处理其他项的位置
        productItems.forEach((item, i) => {
          if (i < index) {
            // 当前项之前的项向左移动
            // 简化计算：每个项向左移动固定距离
            const leftShift = (index - i) * 2.13; // 减小移动距离，避免超出屏幕
            console.log(leftShift, 1);

            item.style.transform = `translateX(-${leftShift}px)`;
          } else if (i > index) {
            // 当前项之后的项向右移动
            // 简化计算：第一个右侧项移动固定距离，后续项递增
            const rightShift = i - index; // 减小移动距离，避免超出屏幕
            console.log(rightShift, 2);

            item.style.transform = `translateX(${rightShift}px)`;
          }
        });
      } else {
        // 鼠标离开时，所有项恢复原位
        productItems.forEach((item) => {
          item.style.transform = "";
        });
      }
    },
  },
  mounted() {
    // 在组件挂载后，为所有产品项添加鼠标悬停事件监听器
    this.$nextTick(() => {
      const productItems = document.querySelectorAll(".product-item");
      productItems.forEach((item) => {
        item.addEventListener("mouseenter", (e) =>
          this.handleProductHover(e, true)
        );
        item.addEventListener("mouseleave", (e) =>
          this.handleProductHover(e, false)
        );
      });
    });
  }
};
</script>

<style lang="scss" scoped>
.mobile-home {
  width: 100%;
  overflow-x: hidden;
  color: #333;
  font-family: "Source Han Sans CN", sans-serif;
}

.section-header {
  text-align: center;
  margin-bottom: 0.533rem;
  /* 20px -> 0.533rem */
}

.section-title {
  font-size: 0.533rem;
  /* 20px -> 0.533rem */
  font-weight: bold;
}

.section-subtitle {
  font-size: 0.373rem;
  /* 14px -> 0.373rem */
  color: #fff;
  margin-top: 0.133rem;
  /* 5px -> 0.133rem */
}

/* 移动端顶部导航 */
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.267rem 0.4rem;
  /* 10px 15px -> 0.267rem 0.4rem */
  background-color: #fff;
  box-shadow: 0 0.053rem 0.267rem rgba(0, 0, 0, 0.1);
  /* 0 2px 10px -> 0 0.053rem 0.267rem */
  z-index: 100;
}

.mobile-logo {
  display: flex;
  align-items: center;
}

.beian a {
  color: #ffffff;
  text-decoration: none;
}
.beian a:hover {
  color: #00ff00;
}

.logo-img {
  height: 0.8rem;
  /* 30px -> 0.8rem */
  margin-right: 0.133rem;
  /* 5px -> 0.133rem */
}

.logo-text {
  font-size: 0.427rem;
  /* 16px -> 0.427rem */
  font-weight: bold;
}

.menu-icon {
  font-size: 0.64rem;
  /* 24px -> 0.64rem */
  cursor: pointer;
}

/* 移动端菜单 */
.mobile-menu {
  position: fixed;
  top: 1.333rem;
  /* 50px -> 1.333rem */
  left: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0.053rem 0.267rem rgba(0, 0, 0, 0.1);
  /* 0 2px 10px -> 0 0.053rem 0.267rem */
  z-index: 99;
}

.menu-item {
  padding: 0.4rem;
  /* 15px -> 0.4rem */
  text-align: center;
  border-bottom: 0.027rem solid #f0f0f0;
  /* 1px -> 0.027rem */
}

.menu-item.active {
  color: #7377c6;
  font-weight: bold;
}

/* 移动端内容区域 */
.mobile-content {
  margin-top: 1.333rem;
  /* 50px -> 1.333rem */
  padding-bottom: 0.8rem;
  /* 30px -> 0.8rem */
}

/* 顶部banner区域 */
.mobile-banner-section {
  max-width: 100%;
  height: 21.333rem;
  /* 800px -> 21.333rem */
  background: linear-gradient(135deg, #1a237e, #4a148c) no-repeat;
  background-image: url("@/assets/img/banner.png");
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #fff;
}

.mobile-title {
  font-size: 0.64rem;
  /* 24px -> 0.64rem */
  margin-bottom: 0.267rem;
  /* 10px -> 0.267rem */
  font-weight: bold;
}

.mobile-subtitle {
  font-size: 0.427rem;
  /* 16px -> 0.427rem */
  color: rgba(255, 255, 255, 0.8);
}

/* 公司简介区域 */
.mobile-building-section {
  height: 20rem;
  /* 600px -> 16rem */
  padding: 0.533rem 0.4rem;
  /* 20px 15px -> 0.533rem 0.4rem */
  background-color: #fff;
  display: flex;
  // border: 1px solid red;
  justify-content: center;
  align-items: center;
}

.mobile-image {
  max-width: 12rem;
  /* 450px -> 12rem */
  height: auto;
  display: block;
  border-radius: 0.213rem;
  /* 8px -> 0.213rem */
}

.mobile-article {
  width: 16.16rem;
  /* 531px -> 14.16rem */
  padding: 0 0.267rem;
  /* 0 10px -> 0 0.267rem */
  // border: 1px solid red;
  margin-left: 2.667rem;
  /* 100px -> 2.667rem */

  .CompanyTop {
    display: flex;
    align-items: center;
    margin-bottom: 0.4rem;
    /* 15px -> 0.4rem */

    .CompanyName {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 0.48rem;
      /* 使用rem替代vw，约等于18px */
      color: #030303;
      line-height: 1.067rem;
      /* 40px -> 1.067rem */
    }

    .English {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 0.267rem;
      /* 使用rem替代vw，约等于10px */
      color: #666666;
    }
  }

  p {
    margin-bottom: 0.4rem;
    /* 15px -> 0.4rem */
    // line-height: 1.6;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 0.48rem;
    /* 18px -> 0.48rem */
    color: #666666;
  }
}

/* 核心技术区域 */
.mobile-service-section {
  padding: 1.1rem 0.4rem;
  /* 30px 15px -> 0.8rem 0.4rem */
  background: url("../assets/img/back.png") no-repeat;
  background-size: cover;
  color: #fff;
  height: 14rem;
}

.mobile-service-items {
  display: flex;
  justify-content: center;
  gap: 1.067rem;
  /* 40px -> 1.067rem */
  padding: 0.267rem;
  /* 10px -> 0.267rem */
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.step-icon {
  width: 6.06rem;
  height: 6.22rem;
  border-radius: 10px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-size: cover;
  background-repeat: no-repeat;
  // border: 1px solid red;

  .worksName {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 0.427rem;
    /* 16px -> 0.427rem */
    color: #6652fc;
  }

  .worksDesc {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 0.373rem;
    /* 14px -> 0.373rem */
    color: #666666;
  }
}

.step-icon.active {
  transform: scale(1.05);
  transition: all 0.3s ease;
}

/* 添加step-dot在active状态下的样式 */
.step.active .step-dot {
  background-color: rgba(243, 152, 64, 1);
}

.step-dot {
  width: 1.333rem;
  /* 50px -> 1.333rem */
  height: 1.333rem;
  /* 50px -> 1.333rem */
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.267rem;
  /* 10px -> 0.267rem */
  overflow: visible;
  transition: all 0.3s ease;

  .step-img {
    width: 0.8rem;
    /* 30px -> 0.8rem */
    height: 0.8rem;
    /* 30px -> 0.8rem */
    object-fit: contain;
  }
}

/* 产品服务区域 */
.mobile-product-section {
  padding: 1.2rem 0.4rem;
  height: 27rem;
  /* 30px 15px -> 0.8rem 0.4rem */
  background-color: #f0f4f8;

  /* 600px -> 16rem */
  .section-header {
    text-align: center;
    margin-bottom: 0.533rem;
    /* 20px -> 0.533rem */
  }

  .section-title {
    font-size: 0.533rem;
    /* 20px -> 0.533rem */
    font-weight: bold;
  }

  .section-subtitle {
    font-size: 0.373rem;
    /* 14px -> 0.373rem */
    color: #666666;
    margin-top: 0.133rem;
    /* 5px -> 0.133rem */
  }
}

.product-grid {
  display: flex;
  justify-content: center;
  position: relative;
  perspective: 1000px;
  padding: 20px 0;
  overflow: visible;
}

.product-item {
  width: 5.54rem;
  height: 21.3rem;
  // border: 1px solid red;
  padding: 10px;
  // background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.6s cubic-bezier(0.22, 1, 0.36, 1);
  margin-left: 50px;
  transform-origin: left center;
  position: relative;
  overflow: hidden;
  // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.product-item:hover {
  width: 11.09rem;
  /* 原宽度的2倍 */
  z-index: 10;
  // box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  /* 移除transform属性，由JavaScript控制位置 */
}

.product-grid .product-item {
  /* 所有产品项都有一个基础变换 */
  transition: all 0.6s cubic-bezier(0.22, 1, 0.36, 1);
}

/* 为所有产品项添加不同的过渡延迟，创造波浪效果 */
.product-item:nth-child(1) {
  transition-delay: 0s;
}

.product-item:nth-child(2) {
  transition-delay: 0.05s;
}

.product-item:nth-child(3) {
  transition-delay: 0.1s;
}

.product-item:nth-child(4) {
  transition-delay: 0.15s;
}

.product-item:nth-child(5) {
  transition-delay: 0.2s;
}

.product-item:first-child {
  // background-color: #6c5ce7;
  color: black;
}

.product-item:first-child .product-desc,
.product-item:first-child .more-link {
  color: rgba(255, 255, 255, 0.8);
}

.product-icon {
  width: 5.54rem;
  height: 18.67rem;
  position: relative;
}

.icon-default,
.icon-hover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  transition: opacity 0.3s ease;
  border: 1px solid #fff;
}

.icon-default {
  opacity: 1;

  .title {
    position: absolute;
    top: 14.67rem;
    left: 1.46rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 24px;
    color: #5855fc;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
}

.icon-hover {
  width: 12.16rem;
  height: 21.7rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;

  .desc {
    width: 8.57rem;
    position: absolute;
    // border: 1px solid red;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 24px;
    color: #ffffff;
    text-align: center;
    top: 15rem;
    left: -1.1rem;
    display: flex;
    flex-direction: column;
    .descTitle {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 30px;
      color: #FFFFFF;
      margin-bottom: 10px;
    }
    .descTitle2 {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 26px;
      color: #FFFFFF;
      margin-top: 20px;
    }
  }
}

.product-item:hover .icon-default {
  opacity: 0;
}

.product-item:hover .icon-hover {
  opacity: 1;
}

/* 为每个产品设置不同的默认和悬浮图片 */
.product-item:nth-child(1) .icon-default {
  background-image: url("@/assets/img/product/first.png");
}

.product-item:nth-child(1) .icon-hover {
  background-image: url("@/assets/img/product/one.png");
}

.product-item:nth-child(2) .icon-default {
  background-image: url("@/assets/img/product/second.png");
}

.product-item:nth-child(2) .icon-hover {
  background-image: url("@/assets/img/product/three.png");
}

.product-item:nth-child(3) .icon-default {
  background-image: url("@/assets/img/product/third.png");
}

.product-item:nth-child(3) .icon-hover {
  background-image: url("@/assets/img/product/four.png");
}

.product-item:nth-child(4) .icon-default {
  background-image: url("@/assets/img/product/fourth.png");
}

.product-item:nth-child(4) .icon-hover {
  background-image: url("@/assets/img/product/two.png");
}

.product-info {
  text-align: center;
  width: 100%;
}

.product-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.product-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 15px;
}

.more-link {
  font-size: 14px;
  color: #6c5ce7;
  font-weight: bold;
  cursor: pointer;
  margin-top: 10px;
}


/* 服务流程区域 */
.mobile-liucheng-section {
  height: 12rem;
  padding: 0.8rem 0.4rem;
  /* 30px 15px -> 0.8rem 0.4rem */
  background-color: #fff;
}

.liucheng-img {
  width: 100%;
  max-width: 24.333rem;
  /* 350px -> 9.333rem */
  margin: 1rem auto;
  display: block;
}

/* 扫码下载区域 */
.mobile-code-section {
  padding: 3rem 0.4rem;
  /* 30px 15px -> 0.8rem 0.4rem */
  background: url("@/assets/img/code.png") no-repeat;
  height: 16rem;
  background-size: cover;
  color: #fff;
}

.code-container {
  width: 6.333rem;
  /* 200px -> 5.333rem */
  height: 6.333rem;
  /* 200px -> 5.333rem */
  background: rgba(246, 246, 246, 0.4);
  border-radius: 0.267rem;
  /* 10px -> 0.267rem */
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.267rem;
  /* 10px -> 0.267rem */
}

.code-img {
  width: 5.8rem;
  /* 180px -> 4.8rem */
  height: 5.8rem;
  /* 180px -> 4.8rem */
  border-radius: 0.133rem;
  /* 5px -> 0.133rem */
}

/* 联系我们区域 */
.mobile-map-section {
  padding: 1rem 1rem;
  /* 30px 15px -> 0.8rem 0.4rem */
  background-color: #fff;
  height: 30rem;
}

.mobile-map {
  width: 35rem;
  height: 15.333rem;
  /* 200px -> 5.333rem */
  margin-bottom: 0.533rem;
  /* 20px -> 0.533rem */
  border-radius: 0.267rem;
  /* 10px -> 0.267rem */
  overflow: hidden;
}

.indfoData {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .contact-info {
    width: 45%;
    height: 8.5rem;
    border-right: 1px dashed #ccc;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;

    /* 30px -> 0.8rem */

    .contact-title {
      font-size: 0.48rem;
      /* 18px -> 0.48rem */
      font-weight: bold;
      margin-bottom: 0.267rem;
      /* 10px -> 0.267rem */
    }

    .contact-desc {
      font-size: 0.373rem;
      /* 14px -> 0.373rem */
      color: #666;
      margin-bottom: 0.4rem;
      /* 15px -> 0.4rem */
    }

    .contact-item {
      font-size: 0.373rem;
      /* 14px -> 0.373rem */
      color: #666;
      margin-bottom: 0.133rem;
      /* 5px -> 0.133rem */
    }
  }

  .contact-form {
    width: 45%;
    height: 100%;
    // border-right: 1px dashed #ccc;
    display: flex;
    flex-direction: column;
    // justify-content: space-evenly;
    align-items: center;

    .form-title {
      font-size: 0.48rem;
      /* 18px -> 0.48rem */
      font-weight: bold;
      margin-bottom: 0.4rem;
      margin-top: 2.2rem;
      /* 15px -> 0.4rem */
    }

    .form-input {
      width: 70%;
      height: 1.067rem;
      /* 40px -> 1.067rem */
      border: none;
      border-bottom: 0.027rem solid rgba(153, 153, 153, 0.5);
      /* 1px -> 0.027rem */
      margin-bottom: 0.4rem;
      /* 15px -> 0.4rem */
      padding: 0 0.267rem;
      /* 0 10px -> 0 0.267rem */
      font-size: 0.373rem;
      /* 14px -> 0.373rem */
      outline: none;
      background: none;
    }

    .form-button {
      width: 3.2rem;
      /* 120px -> 3.2rem */
      height: 1.067rem;
      /* 40px -> 1.067rem */
      background: #6652fc;
      border-radius: 0.533rem;
      /* 20px -> 0.533rem */
      color: #fff;
      font-size: 0.427rem;
      /* 16px -> 0.427rem */
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0.533rem auto 0;
      /* 20px auto 0 -> 0.533rem auto 0 */
    }
  }
}


/* 底部区域 */
.mobile-footer {
  background-color: #1a1a2e;
  color: #fff;
  padding: 0.8rem 0.4rem;
  // display: flex;
  // justify-content: space-around;
  /* 30px 15px -> 0.8rem 0.4rem */
}

.footer-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
  padding: 0.8rem 0.4rem;
}

.footer-section {
  margin-bottom: 0.533rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 20px -> 0.533rem */
}

.footer-title {
  font-size: 0.427rem;
  /* 16px -> 0.427rem */
  font-weight: bold;
  margin-bottom: 0.267rem;
  /* 10px -> 0.267rem */
}

.footer-item {
  font-size: 0.373rem;
  /* 14px -> 0.373rem */
  color: #aaa;
  margin-bottom: 0.213rem;
  /* 8px -> 0.213rem */
}

.footer-qrcode {
  margin-bottom: 0.533rem;
  /* 20px -> 0.533rem */

  .qrcode-img {
    width: 2.133rem;
    /* 80px -> 2.133rem */
    height: 2.133rem;
    /* 80px -> 2.133rem */
  }
}

.beian {
  font-size: 0.62rem;
  /* 12px -> 0.32rem */
  color: #aaa;
  text-align: center;
  margin-top: 0.533rem;
  /* 20px -> 0.533rem */
  padding-top: 0.533rem;
  /* 20px -> 0.533rem */
  border-top: 0.027rem solid rgba(255, 255, 255, 0.1);
  /* 1px -> 0.027rem */
}
</style>